import { Injectable } from '@angular/core';
import {
  HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { environment } from './environment';

import { RadiantHttpInterceptor } from '@library/common/http';

@Injectable()
export class PaymentHttpInterceptor extends RadiantHttpInterceptor {
   constructor() {
      super();
   }

   origin(): string {
      return environment.origin;
   }
}

export let httpInterceptor2 = {
   provide: HTTP_INTERCEPTORS,
   useClass: PaymentHttpInterceptor,
   multi: true
};
